import styled, { css } from 'styled-components';
import { HeroStoryblok } from '@/types/generated/storyblok/schema';

export const StyledHero = styled.div<Partial<HeroStoryblok>>`
    position: relative;
    display: flex;
    flex-direction: column;
    height: auto;
    line-height: 6rem;
    margin-bottom: 4rem;

    ${({ theme, large, imageUrl }) => css`
        &:before {
            content: ' ';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: -1;
            background-color: ${theme.color.base.main};
            background-image: url(${imageUrl});
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        ${large
            ? css`
                  min-height: 50vh;
                  height: auto;
                  padding: 5rem 0;
                  &:before {
                      opacity: 0.6;
                  }
              `
            : css`
                  min-height: 16rem;
                  padding: 6rem 0 4rem;
                  &:before {
                      opacity: 0.8;
                  }
              `}
    `}
`;

export const StyledFullHeightContainer = styled.div`
    height: 100%;
    margin: auto 0;
`;

export const StyledCenterAlign = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    gap: 2.4rem;
`;

export const StyledGrid = styled.div`
    display: grid;
    gap: 6.4rem;
    grid-template-columns: repeat(1, 1fr);
    max-width: 40rem;
    margin: 0 auto;

    @media (min-width: 48rem) {
        max-width: 100%;
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const StyledH1 = styled.span`
    font-weight: 600;
    text-shadow: 0 0.3rem 0.4rem rgba(0, 0, 0, 0.4);
`;
